import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IHinhThucMienGiamActionTypes } from "../../action-types/hinh-thuc-mien-giam/IHinhThucMienGiamActionTypes";
import { IHinhThucMienGiamState } from "../../page-state-model/hinh-thuc-mien-giam/IHinhThucMienGiamState";

const initialState: IHinhThucMienGiamState = {
  status: ePageBaseStatus.is_not_initialization,
  sf_hinhthucmiengiams: [],
  is_show_detail_modal: false,
  is_show_delete_confirm: false,
  selection_ids: [],
  nam_hoc: "",
};

export const hinhThucMienGiamReducer = (
  state: IHinhThucMienGiamState = initialState,
  action: IHinhThucMienGiamActionTypes
): IHinhThucMienGiamState => {
  switch (action.type) {
    case "HINH_THUC_MIEN_GIAM_CHANGE_NAM_HOC":
      return { ...state, nam_hoc: action.payload };

    case "HINH_THUC_MIEN_GIAM_LOAD_START":
      return { ...state, status: ePageBaseStatus.is_loading };
    case "HINH_THUC_MIEN_GIAM_LOAD_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        sf_hinhthucmiengiams: action.payload,
      };
    case "HINH_THUC_MIEN_GIAM_LOAD_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        sf_hinhthucmiengiams: [],
      };

    case "HINH_THUC_MIEN_GIAM_SAVE_START":
      return { ...state, status: ePageBaseStatus.is_saving };
    case "HINH_THUC_MIEN_GIAM_SAVE_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
        is_show_detail_modal: false,
      };
    case "HINH_THUC_MIEN_GIAM_SAVE_ERROR":
      return { ...state, status: ePageBaseStatus.is_completed };

    case "HINH_THUC_MIEN_GIAM_DELETE_START":
      return { ...state, status: ePageBaseStatus.is_deleting };
    case "HINH_THUC_MIEN_GIAM_DELETE_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
        is_show_delete_confirm: false,
      };
    case "HINH_THUC_MIEN_GIAM_DELETE_ERROR":
      return { ...state, status: ePageBaseStatus.is_completed };

    case "HINH_THUC_MIEN_GIAM_SHOW_DETAIL_MODAL":
      return {
        ...state,
        is_show_detail_modal: true,
        current_editing: action.payload,
      };
    case "HINH_THUC_MIEN_GIAM_CLOSE_DETAIL_MODAL":
      return {
        ...state,
        is_show_detail_modal: false,
        current_editing: undefined,
      };

    case "HINH_THUC_MIEN_GIAM_SHOW_DELETE_CONFIRM":
      return { ...state, is_show_delete_confirm: true };
    case "HINH_THUC_MIEN_GIAM_CLOSE_DELETE_CONFIRM":
      return { ...state, is_show_delete_confirm: false };

    case "HINH_THUC_MIEN_GIAM_CHANGE_SELECTION_IDS":
      return { ...state, selection_ids: action.payload };

    default:
      return state;
  }
};
